export enum NoteFor {
    Client = 1,
    ClientLocation = 2,
    Staff = 3,
    ClientContact = 4
}